import { Typography } from '@gto/ui/typography'

import { SiteLogo } from '@/components/site-logo'

export type RoomTitleWithLogoProps = { name?: string; logo: string | null }

export const RoomTitleWithLogo = ({ name = '', logo }: RoomTitleWithLogoProps) => {
  return (
    <div className="flex items-center gap-4 md:gap-2 sm:flex-col">
      <div className="flex-[0_0_auto]">
        <SiteLogo
          key={logo}
          logo={logo}
          name={name}
          size="small"
        />
      </div>
      <Typography variant="body2">{name}</Typography>
    </div>
  )
}
